/**
 * Checks if a resource key represents an example resource.
 * Example resources have keys that start with 'ld-example-'.
 *
 * @param key - The resource key to check
 * @returns true if the key starts with 'ld-example-', false otherwise
 */
export function isExampleResource(key?: string | null): boolean {
  return !!key && key.startsWith('ld-example-');
}
